export default __webpack_public_path__ + "static/media/phonepe.ca535957.svg";